import React from 'react'
import ReactDOM from 'react-dom/client'
import { Analytics, type BeforeSendEvent } from '@vercel/analytics/react'
import App from './App'
import './styles.css'

const analyticsMode = window.location.hostname === 'check-in.fit' ? 'production' : 'development'

function keepPagePathOnly(event: BeforeSendEvent): BeforeSendEvent {
  const url = new URL(event.url)
  url.search = ''
  url.hash = ''
  return { ...event, url: url.toString() }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Analytics mode={analyticsMode} debug={false} beforeSend={keepPagePathOnly} />
  </React.StrictMode>,
)
